import {
  GetAllPartnersRequestBuilder,
  GetPartnersCountRequestBuilder,
  UpdatePartnerRequestBuilder,
  CreatePartnersRequestBuilder,
  UpdatePartnerStatusRequestBuilder,
  GetAllPartnersInventoryRequestBuilder,
  CreatePartnerWithLogoRequestBuilder,
  UpdatePartnerWithLogoRequestBuilder,
  RemoveLogoRequestBuilder,
  GetPartnerLogoRequestBuilder,
} from '../partners/partners';

import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class PartnersRepository {
  getPartners = async (actions: any) => {
    const makeRequest = new GetAllPartnersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetPartnersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getPartnerWithId = async (actions: any) => {
    const makeRequest = new GetAllPartnersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updatePartner = async (actions: any) => {
    const {body, pagination} = actions.payload;
    const makeUpdateRequest = new UpdatePartnerRequestBuilder()
      .data(body)
      .build();

    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return pagination;
  };
  updatePartnerAdmin = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeUpdateRequest = new UpdatePartnerRequestBuilder()
      .id(id)
      .data(body)
      .build();

    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return pagination;
  };
  createPartner = async (actions: any) => {
    const {body, pagination} = actions.payload;
    const makeRequest = new CreatePartnersRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return pagination;
  };
  createPartnerWithLogo = async (actions: any) => {
    const {body, pagination, params} = actions.payload;
    const makeRequest = new CreatePartnerWithLogoRequestBuilder()
      .params(params)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updatePartnerStatus = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeUpdateStatusRequest = new UpdatePartnerStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return pagination;
  };
  updatePartnerWithLogo = async (actions: any) => {
    const {params, body} = actions.payload;
    const makeUpdateStatusRequest = new UpdatePartnerWithLogoRequestBuilder()
      .params(params)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateStatusRequest);
    return response;
  };
  removeLogo = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const makeUpdateStatusRequest = new RemoveLogoRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return pagination;
  };
  getPartnerLogo = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new GetPartnerLogoRequestBuilder().id(id).build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getParentsInventory = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new GetAllPartnersInventoryRequestBuilder()
      .id(id)
      .params(flattenObject({sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new PartnersRepository();
